import React from "react";
import { useParams } from "react-router-dom";
import { Typography, Box } from "@mui/material";

const LanguageContentPage = () => {
  const { language } = useParams(); // Extract 'java' from /programming-content/java

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {language.charAt(0).toUpperCase() + language.slice(1)} Tutorials
      </Typography>
      <Typography variant="body1">
        Select a topic from the sidebar to start learning {language}!
      </Typography>
    </Box>
  );
};

export default LanguageContentPage;
